import TagInput from './TagInput';

// export types
export type { TagInputProps } from './TagInput';

// export components
export { TagInput };
export default TagInput;
